import { render, staticRenderFns } from "./messagedetail.vue?vue&type=template&id=e7d5125c&scoped=true&"
import script from "./messagedetail.vue?vue&type=script&lang=js&"
export * from "./messagedetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d5125c",
  null
  
)

export default component.exports